import { compose } from 'redux';
import { connect } from 'react-redux';
import withBaseDrawer from 'components/common/Drawers/withBaseDrawer';
import { userIdSelector } from 'redux-core/auth/selectors';
import { getSelectedProductionIdSelector } from 'redux-core/overview/selectors';

const mapStateToProps = (state) => ({
  currentUserId: userIdSelector(state),
  productionId: getSelectedProductionIdSelector(state),
});

export default compose(connect(mapStateToProps), withBaseDrawer);
